import { gql } from "@apollo/client";

export const GET_SOLICITUDES_GESTION_CRED = gql`
query getSolicitudesGestionCrediticia($filter: GestionCrediticiaFilterInput!) {
    solicitudesGestionCrediticia(filter: $filter)
    {
        success,
        error,
        valorEsperado {          
          razonSocial,
          nombre,
          apellido,
          idDelegacion,
          tipo,
          idEvaluacion,
          idCliente,
          cUIT,
          usuario,
          fechaEstadoCrediticio,
          fechaNotificacionCrediticia,
          bloqueoSAP,
          idEstadoCrediticio,
          tieneAdjunto
        }
    }
}`;